import { getUserAttributes } from '@noths/polaris-client-user-configuration';

/**
 * Resolves the Cognito ID JWT used as `x-id-token` for basket-api GraphQL.
 * Tries `Auth.currentSession()` first (reliable when `currentAuthenticatedUser`
 * omits `signInUserSession`), then falls back to `getUserAttributes().idToken`.
 */
export async function getBasketIdToken(): Promise<string | undefined> {
  const auth = window.Amplify?.default?.Auth as
    | {
        currentSession?: () => Promise<unknown>;
      }
    | undefined;

  if (auth && typeof auth.currentSession === 'function') {
    try {
      const session = (await auth.currentSession()) as {
        getIdToken?: () => { getJwtToken: () => string };
        idToken?: { jwtToken?: string };
      };

      if (typeof session.getIdToken === 'function') {
        const jwt = session.getIdToken().getJwtToken();
        if (jwt) {
          return jwt;
        }
      }

      const jwt = session.idToken?.jwtToken;
      if (jwt) {
        return jwt;
      }
    } catch {
      /* unauthenticated or session unavailable */
    }
  }

  const attributes = await getUserAttributes();
  return attributes?.idToken ?? undefined;
}
